import { AbstractControl, ValidationErrors } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { validateDependentField } from "./validate-dependent-field";

export function validateName(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
  const requiredFields = ['firstName', 'lastName'];
  return validateDependentField(control, field, requiredFields, 'required');
}
